import styled, { css } from 'styled-components';

export const MenuAnchor = styled.div<{ $inline: boolean }>`
  ${({ $inline }) =>
    $inline
      ? css`
          position: relative;
        `
      : css`
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 2;
        `}
`;

export const MenuPosition = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 30;
`;
